/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  VirtualProductOptions.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
*
* By            : E860178
* On            : Oct 24, 2019
* Description   : Category Name added to Save cart details - ASDS-1598
*
* By            : E844276
* On            : Oct 24, 2019
* Description   : Category Name added to Save cart details - ASDS-115
*
* By            : E844276
* On            : Feb 17, 2020
* Description   : ASDS-954 - Verbiage Changes
******************************************************************************/
import React from 'react';
import { Grid, Button } from '@scuf/common';
import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

interface IVirtualProductProps {
    onClickConfigureButton: any;
    onClickAPUConfiguration: any;
    product: any;
    system: string;
    categoryName: string;
}

/**
* @description Displays configure options.
*/
function VirtualProductOptions(props: IVirtualProductProps) {
    return (
        <React.Fragment>
            <Grid.Row className="fullwidthRow">
                <Grid.Column className="configure-button-container">
                    {props.categoryName.toLowerCase() === CheckoutConstants.ASPIRE_CATEGORY_NAME  ?
                    <Button type="primary" content="configure" size="small"
                        className="pull-right co-primary-button"
                        onClick={() => props.onClickConfigureButton(props.product, props.system,props.categoryName)} />
                    :
                    <Button type="primary" content="configure" size="small"
                        className="pull-right co-primary-button"
                        onClick={() => props.onClickAPUConfiguration(props.product, props.system, props.categoryName)} />
                    }
                </Grid.Column>
            </Grid.Row>
        </React.Fragment>
    );
}

export default VirtualProductOptions;